import React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';
import { Heading3, TextLink } from '@lightspeed/flame/Text';

import { StyledAlert } from './B2BItemsListing.styles';

export function B2BBanner({ onBannerClose }: { onBannerClose: () => void }) {
  return (
    <StyledAlert onClose={onBannerClose}>
      <Flex>
        <Box data-test="b2b-banner">
          <Heading3>Introducing the NuORDER Catalog</Heading3>
          Find many of your favorite items from our new network of brands <br />
          <TextLink
            target="_blank"
            rel="noopener noreferrer"
            href="https://retail-support.lightspeedhq.com/hc/en-us/articles/25746313791387-Importing-items-with-B2B-Catalog"
          >
            Learn more
          </TextLink>
        </Box>
        <Box>
          <img src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/b2b/new-b2b.svg" alt="New B2B" width="98px" />
        </Box>
      </Flex>
    </StyledAlert>
  );
}
